export enum VIRTUAL_CARD_STATUS_ENUMERATION {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  EXPIRED = 'EXPIRED',
  DISABLED = 'DISABLED',
}
